export default __webpack_public_path__ + "static/media/_ic_speed_swap.3175f54c.svg";